var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.443,25.402c-0.929-0.536-2.083-0.535-3.01,0l-14.638,8.451c-1.035,0.598-2.216,0.915-3.414,0.915H33.4 c-5.007,0-9.2,3.937-9.345,8.776c-0.074,2.473,0.832,4.81,2.552,6.582c1.245,1.282,2.799,2.141,4.497,2.522v16.354 c0,1.104,0.896,2,2,2h9.174c0.904,0,1.695-0.605,1.931-1.479l4.499-16.648h0.674c1.197,0,2.378,0.316,3.415,0.916l14.638,8.45 c0.464,0.268,0.983,0.401,1.504,0.401s1.042-0.134,1.506-0.402c0.929-0.536,1.505-1.535,1.505-2.606V28.01 C71.949,26.938,71.372,25.938,70.443,25.402z M40.747,67.002h-5.643V52.875h9.46L40.747,67.002z M67.949,57.92l-13.151-7.593 c-1.644-0.95-3.517-1.452-5.416-1.452h-2.206H33.104c-1.378,0-2.667-0.545-3.627-1.534c-0.96-0.989-1.466-2.295-1.424-3.676 c0.082-2.7,2.48-4.896,5.347-4.896h15.982c1.899,0,3.772-0.502,5.415-1.451l13.152-7.593V57.92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.bde9e5f16b06991c4f7d6509dea51979.svg";
export { ForwardRef as ReactComponent };